<template lang="pug">
.intro-container
  .header(:class="$mq")
    img.logo(:class="$mq" src="@/assets/img/moonly-full-blanc.png" alt="Logo Moonly")
    SocialButtons.social-networks
  .content(:class="$mq")
    .image-box
      img(src="@/assets/img/accueil-moonly-app-symptothermie-suivi-cycle-ovulation-medium.png" alt="Page d'accueil de l'application mobile Moonly")
    h1.title moonly
    h3.subtitle Explore ta fertilité avec sérénité
    .description
      span Utilise la&nbsp;
      strong symptothermie
      span &nbsp;pour une&nbsp;
      strong contraception sans hormones
      span &nbsp;(taux d'efficacité de&nbsp;
      strong 98 %¹
      span ) ou pour&nbsp;
      strong tomber enceinte
      span &nbsp;plus facilement, grâce au suivi de ton&nbsp;
      strong ovulation.
    .fineprint
      span ¹ Supérieur à l'efficacité réelle de la&nbsp;
      strong pilule
      span , d'après l'
      span.link(@click="open('https://www.who.int/fr/news-room/fact-sheets/detail/family-planning-contraception')") Organisation Mondiale de la Santé (OMS)
      span &nbsp;et la&nbsp;
      span.link(@click="open('https://www.has-sante.fr/upload/docs/application/pdf/2013-05/contraception_freins_reco2clics-5.pdf')") Haute Autorité de Santé (HAS)
    DownloadButtons.download-buttons
</template>

<script>
import SocialButtons from '@/components/SocialButtons'
import DownloadButtons from '@/components/DownloadButtons'

export default {
  name: 'Intro',
  components: {
    SocialButtons,
    DownloadButtons
  },
  methods: {
    open (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-container {
  display: grid;
  grid-template-rows: auto 1fr;
  color: white;
}

.header {
  display: grid;
  padding-top: 20px;
  align-items: center;

  &.phone,
  &.tablet-portrait {
    grid-template-columns: 1fr;
    grid-template-rows: 100px 60px;
    grid-template-areas:
      "logo"
      "socials";
    justify-items: center;
  }

  &.tablet-landscape,
  &.desktop,
  &.large-desktop {
    grid-template-columns: auto 1fr auto;
    grid-template-rows: 100px;
    grid-template-areas: "logo . socials";
    padding: {
      left: 30px;
      right: 30px;
    }
  }

  &.large-desktop {
    grid-template-rows: 200px;
  }

  .logo {
    grid-area: logo;
    width: 350px;
    height: auto;
    max-width: 80vw;

    &.large-desktop {
      width: 600px;
    }
  }

  .social-networks {
    grid-area: socials;
  }
}

.content {
  display: grid;
  justify-items: center;
  align-items: center;
  justify-content: center;

  &.phone,
  &.tablet-portrait,
  &.tablet-landscape {
    $spacing: 40px;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas:
      "subtitle"
      "description"
      "fineprint"
      "img"
      "download";
    row-gap: $spacing;
    margin: {
      top: 40px;
      bottom: $spacing;
    }

    .title {
      display: none;
    }
  }

  &.desktop,
  &.large-desktop {
    grid-template-columns: auto auto;
    grid-template-rows: 35% 10% 15% 10% 1fr;
    grid-template-areas:
      "img title"
      "img subtitle"
      "img description"
      "img fineprint"
      "img download";
    column-gap: 10%;

    .image-box {
      img {
        height: 70vh;
      }
      justify-self: right;
      min-height: 460px;
    }
  }

  &.phone > .image-box {
    height: fit-content;
    img {
      max-height: 600px;
    }
  }

  &.large-desktop {
    .image-box > img {
      max-height: 1600px;
    }

    .title {
      font-size: 260px;
    }

    .subtitle {
      font-size: 80px;
      max-width: 1000px;
    }

    .description {
      font-size: 60px;
      max-width: 1000px;
    }

    .fineprint {
      font-size: 30px;
      max-width: 1000px;
    }
  }

  &.phone > .subtitle {
    max-width: 80%;
    font-size: 30px;
  }

  .image-box {
    grid-area: img;
    width: fit-content;

    img {
      width: auto;
      height: auto;
      max-height: 800px;
      min-height: 400px;
      max-width: 80vw;
      $shadow: drop-shadow(20px 20px 20px rgba(black, 0.2));
      -webkit-filter: $shadow;
      filter: $shadow;
    }
  }

  .title {
    grid-area: title;
    font-size: 130px;
    align-self: end;
    $shadow: drop-shadow(5px 5px 10px rgba(black, 0.1));
    -webkit-filter: $shadow;
    filter: $shadow;
    font-weight: 700;
  }

  .subtitle {
    grid-area: subtitle;
    font-size: 45px;
    text-align: center;
    max-width: 650px;
    font-weight: light;
  }

  .description {
    grid-area: description;
    font-size: 20px;
    text-align: center;
    max-width: 580px;
    font-weight: 200;

    strong {
      font-weight: 500;
    }
  }

  .fineprint {
    grid-area: fineprint;
    font-size: 13px;
    text-align: center;
    max-width: 460px;
    font-weight: 200;

    strong {
      font-weight: 300;
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .download-buttons {
    grid-area: download;
    align-self: start;
  }
}
</style>
